import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { UserModule } from './user/user.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';

import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './interceptors/loader.interceptors';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { APIKeyInterceptor } from './interceptors/api-key.intercpetor';
import { SsoComponent } from './sso/sso.component';
//import { UserSessionComponent } from './dashboard/user-session/user-session.component';
//import { AuditTrailComponent } from './dashboard/audit-trail/audit-trail.component';


@NgModule({
  declarations: [
    AppComponent,
    SsoComponent
    //UserSessionComponent
    //AuditTrailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    UserModule,
    DashboardModule,
    SharedModule,
    HttpClientModule
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: APIKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
